class PrimaryDashboardActions {
  static PRIMARY_DASHBOARD_REQUEST = "PRIMARY_DASHBOARD_REQUEST";
  static PRIMARY_DASHBOARD_SUCCESSFUL = "PRIMARY_DASHBOARD_SUCCESSFUL";
  static PRIMARY_DASHBOARD_FAILED = "PRIMARY_DASHBOARD_FAILED";

  static primaryDashboardRequest() {
    return {
      type: this.PRIMARY_DASHBOARD_REQUEST,
      data: []

    };
  }
  static primaryDashboardSuccessul(data) {
    return {
      type: this.PRIMARY_DASHBOARD_SUCCESSFUL,
      data
    };
  }
  static primaryDashboardFailed(error) {
    return {
      type: this.PRIMARY_DASHBOARD_FAILED,
      error
    };
  }
}

export default PrimaryDashboardActions;
